
module.exports = {
	status: 'ready',
	title: 'Accordion',
	notes: '',
	context: {
		items: [
			{title:'Title 1', content:'<p>Vi uppskattar avancerade <a href="#">helikoptrar</a>, <a href="#">ubåtar</a> och <a href="#">flygplan</a>. Och vi tar vårt uppdrag att leverera materiel och tjänster till Sveriges försvar på största allvar. Men vi är mycket mer än så. Vi är ett av Sveriges bästa karriärföretag.</p>'},
			{title:'Title 2', content:'<p>Vi uppskattar avancerade <a href="#">helikoptrar</a>, <a href="#">ubåtar</a> och <a href="#">flygplan</a>. Och vi tar vårt uppdrag att leverera materiel och tjänster till Sveriges försvar på största allvar. Men vi är mycket mer än så. Vi är ett av Sveriges bästa karriärföretag.</p>'},
			{title:'Title 3', content:'<p>Vi uppskattar avancerade <a href="#">helikoptrar</a>, <a href="#">ubåtar</a> och <a href="#">flygplan</a>. Och vi tar vårt uppdrag att leverera materiel och tjänster till Sveriges försvar på största allvar. Men vi är mycket mer än så. Vi är ett av Sveriges bästa karriärföretag.</p>'},
		]
	},
};
